import { createRouter, createWebHistory } from "vue-router";
import dashboard from "@/router/dashboard/dashboard";
import trainingCourseAdmin from "@/router/studea-manager/studea-manager";
import globalAdmin from "@/router/admin/admin";
import login from "@/router/login/login";
import error from "@/router/error/error";
import profile from "@/router/profile/profile";
import { accessManager } from "@/services/security/access-manager";
import sharedDocument from "@/router/shared-document/shared-document";
import trainingCourseDuplicateView from "@/router/duplicate/duplicate";
import indentSheet from "@/router/indent-sheet/indend-sheet";
import driverLicenceList from "@/router/driver-licence/driver-licence";
import releaseNotes from "@/router/release-note/release-note";
import redirectedRoute from "@/router/redirected-route/redirected-route";

const pathsToRedirect = [
  "inscription",
  "manage/inscription",
  "les-inscriptions-3",
  "gestion-globale-des-inscriptions",
  "recrutement",
  "document-registration",
  "piloting",
  "sl",
];

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  //Redirect inscription V3 to V2
  {
    path: `/:prefix(${pathsToRedirect.join("|")})/:catchAll(.*)*`,
    redirect: (to) => {
      const fullUrl = `${window.location.origin}${to.fullPath}`;
      return {
        path: "/redirected-route",
        query: { from: fullUrl },
      };
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/error",
  },
  dashboard,
  trainingCourseAdmin,
  globalAdmin,
  login,
  error,
  profile,
  sharedDocument,
  trainingCourseDuplicateView,
  indentSheet,
  driverLicenceList,
  releaseNotes,
  redirectedRoute,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  accessManager.checkRoleAccess(to, from).then((res) => {
    if (res) {
      next();
    }
  });
});

export default router;
